import { PersonRequest } from "@plinknz/tah-website-elements";

import { equalish } from "../boolean-functions";
import { stringifyAddressFinder } from "../address";
import { getPhone, PhoneType } from "../phone";
import type { SVGLine } from "./svg-config";
import { AddressMeta } from "../../components/form/address-finder-input";

interface GetPersonalChangesProps {
  member: PersonRequest;
  phone: string;
  email: string;
  addressfinder: AddressMeta;
  default?: PersonRequest;
  applicant?: string;
  name?: string;
}

export function getPersonalChanges(data: GetPersonalChangesProps): SVGLine[] {
  const { member, phone, email } = data;
  const svgLines: SVGLine[] = [];

  const existingCell = getPhone({ phone: member.phone, type: PhoneType.Cell })
    ?.value;
  const existingPhone = getPhone({ phone: member.phone, type: PhoneType.Home })
    ?.value;

  if (!equalish(phone, existingCell) && !equalish(phone, existingPhone)) {
    svgLines.push({ label: "Phone", text: phone });
  }

  if (!equalish(email, member.email[0]?.value)) {
    svgLines.push({ label: "Email", text: email });
  }

  if (svgLines.length !== 0) {
    svgLines.unshift({ heading: "Contact Changes" });
  }

  return svgLines;
}

export function getAddressChanges(data: GetPersonalChangesProps): SVGLine[] {
  const { member, addressfinder } = data;
  const svgLines: SVGLine[] = [];

  if (addressfinder) {
    const existing = member.address[0];

    if (
      (!existing && addressfinder.address_line_1) ||
      !equalish(existing.line1, addressfinder.address_line_1) ||
      !equalish(existing.line2, addressfinder.address_line_2) ||
      !equalish(existing.city, addressfinder.city) ||
      !equalish(existing.postcode, addressfinder.postcode)
    ) {
      const newAddress = stringifyAddressFinder(addressfinder);
      svgLines.push({
        label: "Address",
        text: newAddress,
      });
    }
  }

  if (svgLines.length !== 0) {
    svgLines.unshift({ heading: "Address Changes" });
  }

  return svgLines;
}
